import React from 'react';

const CautionIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8.49023C14 11.8039 11.3137 14.4902 8 14.4902C4.68629 14.4902 2 11.8039 2 8.49023C2 5.17653 4.68629 2.49023 8 2.49023C11.3137 2.49023 14 5.17653 14 8.49023ZM8.66667 5.82357C8.66667 6.19176 8.36819 6.49023 8 6.49023C7.63181 6.49023 7.33333 6.19176 7.33333 5.82357C7.33333 5.45538 7.63181 5.1569 8 5.1569C8.36819 5.1569 8.66667 5.45538 8.66667 5.82357ZM8.5 11.8236V7.82357H7.5V11.8236H8.5Z"
        fill="#4F4F4F"
      />
    </svg>
  );
};

export default CautionIcon;
